import React from "react";
import Main from "./routes";

function App() {
  return (
    <div className="App" style={{ height: "100%" }}>
      <Main />
    </div>
  );
}

export default App;
